// import { useTranslation } from 'react-i18next';
import "./App.css";
import Multistepform from "./components/multistepform";
import "bs-stepper/dist/css/bs-stepper.min.css";
import { BrowserRouter } from "react-router-dom";
import React from "react";

// create react app with php server: https://www.geeksforgeeks.org/how-to-connect-reactjs-as-a-front-end-with-php-as-a-back-end/
// multistep form tutorial: https://blog.devgenius.io/create-a-multi-step-form-with-reactjs-322aa97a2968#1575

// internationalization: https://react.i18next.com/guides/quick-start
// execute the command below in order to generate the app's languages files (see: https://github.com/i18next/i18next-scanner)
// warning: it doesn't save current translations, so add them to a back up file before running it
// i18next-scanner --config src/i18next-scanner.config.js --output src/translations 'src/**/*.{js,jsx}';

const ThemeHvac = React.lazy(() => import("./siteData/hvac/hvac.jsx"));
const ThemeSeguros = React.lazy(() => import("./siteData/seguros/seguros.jsx"));
//const ThemeAbc = React.lazy(() => import("./siteData/abc/abc.jsx"));

const ThemeSelector = ({ children }) => {
  const hostName = window.location.hostname; //localhost
  // console.log("hostname", hostName.toLowerCase());
  // console.log("hostname", hostName.toLowerCase().includes("hvac"));
  // console.log("hostname", hostName.toLowerCase().includes("seguros"));
  return (
    <>
      <React.Suspense fallback={<>hello</>}>
        {hostName.toLowerCase().includes("hvac") && <ThemeHvac />}
        {hostName.toLowerCase().includes("seguros") && <ThemeSeguros />}
      </React.Suspense>
      {children}
    </>
  );
};

function App() {
  // const { t } = useTranslation("global");

  return (
    <ThemeSelector>
      <div className="App">
        <BrowserRouter>
          <Multistepform />
        </BrowserRouter>
      </div>
    </ThemeSelector>
  );
}

export default App;

/*
<div className="App">
      <Navbar style={{background:"#123157", height:"50px"}}>
        <Container style={{width:"990px", padding:"0px"}}>
          <Navbar.Brand>
            <img src={Logo}/>
          </Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="" style={{color:"#fff", borderLeft:"#fff solid 1px", borderRight:"#fff solid 1px"}}>Go back to site</Nav.Link>
          </Nav>
        </Container>
        </Navbar>
      <Multistepform/>
    </div>
*/
